/** The only place `import.meta.env` is read — isolated so Jest (CommonJS,
 * can't parse `import.meta`) can stub it via `__mocks__/env.js`. */
export const API_BASE_URL_OVERRIDE = import.meta.env.VITE_API_URL;
export const IS_DEV = import.meta.env.DEV;
